module.exports = __webpack_public_path__ + "img/companies-buttons-add.d112d722.svg";